import { createFileRoute } from "@tanstack/react-router";
import FertilizerPreferences from "@/components/field/setup/FertilizerPreferences";

export const Route = createFileRoute(
    "/dashboard/fields/$fieldId/setup/fertilizer-preferences",
)({
    component: FertilizerPreferencesPane,
});

function FertilizerPreferencesPane() {
    return <FertilizerPreferences />;
}
